import {IconX} from '@tabler/icons-react';
import {ActionIcon} from 'src/design/atoms/ActionIcon';
import type {ActionIconProps} from 'src/design/atoms/ActionIcon';

/**
 * "Delete" row action icon — thin `ActionIcon` wrapper with an X glyph,
 * `color="red"`, defaulting `tooltipText` to "Delete".
 * @registry Icon-only "delete" action for table rows/toolbars.
 *
 * Ported from `library-m/components/action-icons/DeleteActionIcon`. Prop
 * surface kept identical (all `ActionIcon` props pass through, `tooltipText`
 * defaults to "Delete" but can still be overridden). One deviation: the
 * original hard-coded `size: 'small'`, which is not a valid Mantine
 * `ActionIcon` size token — ported as `size="sm"` (the atom's own default),
 * matching the visible behavior Mantine actually rendered.
 */
export type DeleteActionIconProps = Partial<ActionIconProps>;

export const DeleteActionIcon = ({
  color = 'red',
  size = 'sm',
  tooltipText = 'Delete',
  ...props
}: DeleteActionIconProps) => (
  <ActionIcon color={color} size={size} tooltipText={tooltipText} {...props}>
    <IconX />
  </ActionIcon>
);
